import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=682b5a2f"
import script from "./SubmissionForm.vue?vue&type=script&lang=js"
export * from "./SubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports